var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "intro-container",
      style: { backgroundImage: "url(" + _vm.imageUrl(_vm.heroImage) + ")" }
    },
    [
      _c("logo"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "wtw-container small" }, [
        _c(
          "div",
          { staticClass: "buttons-container" },
          [
            _c(
              "router-link",
              { staticClass: "button pink", attrs: { to: "/signup/1" } },
              [_vm._v("Get Started")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "button transparent outline",
                attrs: { to: { name: "login", params: { fromIntro: true } } }
              },
              [_vm._v("Sign In")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", { staticClass: "large" }, [
        _vm._v("Meet your pocket-sized personal stylist.")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3309eaa9", { render: render, staticRenderFns: staticRenderFns })
  }
}